import { render, staticRenderFns } from "./PendingExpenses.vue?vue&type=template&id=07bbeec9&scoped=true&lang=pug&"
import script from "./PendingExpenses.vue?vue&type=script&lang=js&"
export * from "./PendingExpenses.vue?vue&type=script&lang=js&"
import style0 from "./PendingExpenses.vue?vue&type=style&index=0&id=07bbeec9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbeec9",
  null
  
)

export default component.exports